import React from 'react';
import Box from '@material-ui/core/Box';
import useTheme from '@material-ui/core/styles/useTheme';
import { useTranslation } from 'react-i18next';
import Styled from './style';

const Apology = ({ apiStatus}) => {
  const theme = useTheme();
  const i18n = useTranslation();
  return (
    <>
    <Box style={{ ...theme.palette.contentStyle }}>
    <Styled.NotFoundWrapper>
          <h1>{i18n.t('apology')}...</h1>
          <p>{i18n.t('page moved')}</p>
          <p>
            {i18n.t('Please send us feedback')}
            <a href="/feedback" className="here" target="_blank">
              {i18n.t('here')}{' '}
            </a>
          </p>
        </Styled.NotFoundWrapper>
        </Box>
    </>
  );
};

export default Apology;
